import searchBarConfig from '../configs';

const initialState = {
  config: searchBarConfig,
};

export default (state = initialState) => state;
